import React from "react";
import * as Icons from "lucide-react";
import { FEATURES } from "../mock";

export default function Features() {
  return (
    <section id="features" className="py-24 bg-[#070d19] border-y border-[rgba(46,155,255,0.1)]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center reveal">
          <span className="text-[12px] tracking-[0.25em] text-[#2e9bff] font-semibold">UNMATCHED FEATURES</span>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-white mt-4">Built for <span className="text-blue-grad">Winners</span></h2>
          <p className="text-slate-400 mt-4 max-w-2xl mx-auto">Every feature engineered to give you an edge in the gold market. Precision, protection, and profits — all in one.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
          {FEATURES.map((f, i) => {
            const Icon = Icons[f.icon] || Icons.Sparkles;
            return (
              <div key={i} className="reveal group glass-card rounded-2xl p-6 hover:border-[rgba(46,155,255,0.5)] transition-all duration-300 hover:-translate-y-1.5">
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-xl grid place-items-center bg-[rgba(46,155,255,0.12)] border border-[rgba(46,155,255,0.25)] group-hover:bg-[rgba(46,155,255,0.2)] transition-colors">
                    <Icon className="w-6 h-6 text-[#2e9bff]" />
                  </div>
                  <span className="text-[10.5px] tracking-wide text-slate-400 px-2.5 py-1 rounded-full bg-[#0f1b30] border border-white/5">{f.tag}</span>
                </div>
                <h3 className="text-white font-semibold text-lg mt-5">{f.title}</h3>
                <p className="text-slate-400 text-sm mt-2 leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
